import '../index.css'
import '../asset/main.css'
import { Outlet, Link } from "react-router-dom";
import LeftIcon from 'remixicon-react/ArrowDropRightFillIcon'
import img from '../asset/images/plant.svg'
import imgdoc from '../asset/images/document.svg'
import imgteam from '../asset/images/team.svg'
import { useEffect, useState } from 'react';
import { getHome } from '../firebase';

import { useDarkMode } from "../DarkModeContext";

export default function Home({ location }) {

  const [introduce, setIntroduce] = useState();
  const [imgcover, setImgCover] = useState();
  const [listSkill, setListSkill] = useState();

  const { darkMode, toggleDarkMode } = useDarkMode();



  useEffect(() => {
    const fetchData = async () => {
      try {
        const homeData = await getHome();

        const intro = homeData[0].introduce;
        setIntroduce(intro)

        const imgcov = homeData[0].imagecover;
        setImgCover(imgcov)

        const listskil = homeData[0].skills;

        setListSkill(listskil)

        console.log(homeData);


      } catch (error) {
        console.error('Error fetching about data:', error);
      }
    };

    fetchData();
  }, []);



  const COLORS = ['#bbf7d0', '#99f6e4', '#bfdbfe', '#ddd6fe', '#f5d0fe', '#fed7aa', '#fee2e2'];
  const TAGS = listSkill ? listSkill : []
  const DURATION = 15000;
  const ROWS = 3;
  const TAGS_PER_ROW = 5;

  const random = (min, max) => Math.floor(Math.random() * (max - min)) + min;
  const shuffle = (arr) => [...arr].sort(() => .5 - Math.random());

  const InfiniteLoopSlider = ({ children, duration, reverse = false }) => {
    return (
      <div className='loop-slider' style={{
        '--duration': `${duration}ms`,
        '--direction': reverse ? 'reverse' : 'normal'
      }}>
        <div className='inner'>
          {children}
          {children}
        </div>
      </div>
    );
  };

  const Tag = ({ text }) => (
    <div className={darkMode ? 'tag-dark' : 'tag'}><span>#</span> {text}</div>
  );





  return (
    <div className='home'>
      <div className="wrap-home-top">
        <div className={darkMode ? "home-introduce-dark" : "home-introduce"}>
          <div className="wrap-introduce">
            <div className="wrap-introduce_1">
              <div className='intro-welcome'>
                <h1>Xin chào, tôi là Trần Duy Thanh 👋</h1>
              </div>
              <div className='intro-welcome'>
                {introduce ? (<p>{introduce ? introduce : ''}</p>) : (<div className="loading-indicator-container">
                  <div className="loading-indicator"></div>
                </div>)}
              </div>
            </div>
            <div className={darkMode ? 'wrap-introduce_2-dark' : 'wrap-introduce_2'}>
              <img src="https://firebasestorage.googleapis.com/v0/b/profile-beb01.appspot.com/o/avatar.jpg?alt=media&token=5544be63-4f99-46f4-ba6c-2e5fbe94c579" alt="" />
            </div>
          </div>
        </div>
        <Link className={darkMode ? 'home-mywork-dark' : 'home-mywork'} to='/work'>
          <div className="home-mywork-2">
            <div className="mywork-left">
              <div className="mywork-left_title">
                <h1>Dự án</h1>
              </div>
              <div className="mywork-left_explore">
                <p>Khám phá</p>
                <LeftIcon size={30}></LeftIcon>
              </div>

            </div>
            <div className="mywork-right">
              <img src={img}></img>
            </div>
          </div>
        </Link>

        <Link className={darkMode ? 'home-aboutme-dark' : 'home-aboutme'} to='/about'>
          <div className="home-aboutme-2">
            <div className="aboutme-left">
              <img src={imgdoc}></img>
            </div>
            <div className="aboutme-right">
              <div className="aboutme-left_title">
                <h1>Thông tin</h1>
              </div>
              <div className="aboutme-left_explore">
                <p>Khám phá</p>
                <LeftIcon size={30}></LeftIcon>
              </div>
            </div>
          </div>
        </Link>

      </div>
      <div className="wrap-home-bottom">
        <div className={darkMode ? 'home-available-dark' : 'home-available'}>
          <div className="wrap-avalable">
            <div className="available-title">
              <h1>Liên hệ công việc 🏢</h1>
            </div>
            <div className="available-desc">
              <p>Tôi hiện đang tìm kiếm các cơ hội và hợp tác mới. Nếu bạn có dự án hoặc vị trí nào muốn thảo luận, hãy liên hệ với tôi!</p>
            </div>
            <div className="wrap-button-see">
              <div className={darkMode ? 'button-connect-dark' : 'button-connect'}>
                <a href="mailto:ttranduy999@gmail.com" className="">
                  Liên hệ 📬
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* <div className={darkMode ? 'home-available-dark' : 'home-available'}>
          <div className="wrap-avalable">
            <div className="available-title">
              <h1>Available for work</h1>
            </div>
            <div className="available-desc">
              <p>Reach me directly, let's talk</p>
            </div>
            
          </div>

        </div> */}

        {/* <div className="wrap-button-see">
              <div className="button-connect">
                <p>Connect</p>
              </div>
            </div> */}

        <div className="home-image">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
            xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="4%" height="4%" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMax slice">
            <defs>
              <linearGradient id="bg">
                <stop offset="0%" style={{ stopColor: 'rgba(130, 158, 249, 0.06)' }}></stop>
                <stop offset="50%" style={{ stopColor: 'rgba(76, 190, 255, 0.6)' }}></stop>
                <stop offset="100%" style={{ stopColor: 'rgba(115, 209, 72, 0.2)' }}></stop>
              </linearGradient>
              <path id="wave" fill="url(#bg)" d="M-363.852,502.589c0,0,236.988-41.997,505.475,0
	s371.981,38.998,575.971,0s293.985-39.278,505.474,5.859s493.475,48.368,716.963-4.995v560.106H-363.852V502.589z" />
            </defs>
            <g>
              <use href='#wave' opacity=".3">
                <animateTransform
                  attributeName="transform"
                  attributeType="XML"
                  type="translate"
                  dur="5s"
                  calcMode="spline"
                  values="280 230; -334 180; 270 230"
                  keyTimes="0; .5; 1"
                  keySplines="0.42, 0, 0.58, 1.0;0.42, 0, 0.58, 1.0"
                  repeatCount="indefinite" />
              </use>
              <use href='#wave' opacity=".6">
                <animateTransform
                  attributeName="transform"
                  attributeType="XML"
                  type="translate"
                  dur="8s"
                  calcMode="spline"
                  values="-270 230;243 220;-270 230"
                  keyTimes="0; .6; 1"
                  keySplines="0.42, 0, 0.58, 1.0;0.42, 0, 0.58, 1.0"
                  repeatCount="indefinite" />
              </use>
              <use href='#wave' opacty=".9">
                <animateTransform
                  attributeName="transform"
                  attributeType="XML"
                  type="translate"
                  dur="6s"
                  calcMode="spline"
                  values="0 290;-140 200;0 230"
                  keyTimes="0; .4; 1"
                  keySplines="0.42, 0, 0.58, 1.0;0.42, 0, 0.58, 1.0"
                  repeatCount="indefinite" />
              </use>
            </g>
          </svg>
        </div>

        <div className={darkMode ? "home-skill-dark" : "home-skill"}>
          <div className="home-skill-title">
            <h1>Developer skills</h1>
          </div>

          <div className="home-skill-content">
            <div className="home-skill-content_left">
              <div className="wrap-content-skill_left">


                <div className='wrap-list-tag'>
                  {
                    listSkill ? (<div className='tag-list'>
                      {[...new Array(ROWS)].map((_, i) => (
                        <InfiniteLoopSlider key={i} duration={random(DURATION - 5000, DURATION + 5000)} reverse={i % 2}>
                          {shuffle(TAGS).slice(0, TAGS_PER_ROW).map(tag => (
                            <Tag text={tag.nameSkill} key={tag} />
                          ))}
                        </InfiniteLoopSlider>
                      ))}
                      <div className='fade' />
                    </div>) : (<div className="loading-indicator-container">
                      <div className="loading-indicator"></div>
                    </div>)
                  }
                </div>

              </div>
            </div>
            <div className="home-skill-content_right">
              <img src={imgteam}></img>
            </div>
          </div>
        </div>

      </div>
    </div>

  )
}